document.addEventListener("DOMContentLoaded", function () {
  // Initialize cart drawer
  initializeCartDrawer();

  // Subscribe to cart updates if available
  subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
  subscribe(PUB_SUB_EVENTS.cartError, handleCartError);

  function initializeCartDrawer() {
    const cartDrawer = document.getElementById("cart-drawer");

    // Open triggers
    document.querySelectorAll("[data-open-cart]").forEach((button) => {
      button.addEventListener("click", openCartDrawer);
    });

    // Event delegation
    cartDrawer.addEventListener("click", (e) => {
      if (e.target.closest("[data-remove-item]")) {
        e.preventDefault();
        handleRemoveItem(e.target.closest("[data-remove-item]"));
      }
    });

    // Close handlers
    document
      .querySelector(".cart-drawer__close")
      ?.addEventListener("click", closeCartDrawer);
    document
      .querySelector(".cart-drawer__overlay")
      ?.addEventListener("click", closeCartDrawer);
    document.addEventListener(
      "keydown",
      (e) => e.key === "Escape" && closeCartDrawer()
    );

    // Quantity controls
    initQuantityControls();
  }

  async function handleCartUpdate(data) {
    if (data.action === "add") {
      await refreshCartContent(data.variant);
      openCartDrawer();
    }
  }

  function initQuantityControls() {
    // Event delegation for quantity controls
    document.addEventListener("click", async (e) => {
      if (e.target.closest("[data-quantity-up]")) {
        await handleQuantityChange(e.target.closest("[data-quantity-up]"), 1);
      } else if (e.target.closest("[data-quantity-down]")) {
        await handleQuantityChange(
          e.target.closest("[data-quantity-down]"),
          -1
        );
      }
    });
    // Debounced direct input changes (750ms)
    document.addEventListener(
      "input",
      debounce(async (e) => {
        if (e.target.matches("[data-quantity-input]")) {
          const input = e.target;
          const quantityControl = input.closest(".cart-item");
          const stockMaxQuantity = parseInt(quantityControl.dataset.maxQuantity) || 9999;
          // Use the lower of stock availability and global max (3)
          const maxQuantity = Math.min(stockMaxQuantity, 3);
          const newQuantity = parseInt(input.value) || 1;

          if (newQuantity > maxQuantity) {
            const message = maxQuantity === 3
              ? `Maximum 3 per product`
              : `Only ${maxQuantity} available`;
            showStockError(quantityControl, message);
            input.value = maxQuantity;
            return;
          }

          await handleQuantityChange(input, 0); // 0 means use exact input value
        }
      }, 750)
    );
  }

  function showStockError(element, message) {
    // Remove existing error if any
    const existingError = element.querySelector(".stock-error");

    existingError.style.marginTop = "0.5rem";
    existingError.textContent = message;
    // Auto-remove after 3 seconds
    setTimeout(() => {
      existingError.textContent = "";
    }, 3000);
  }

  function handleCartError(error) {
    console.error("Cart Error:", error);
    // Show error UI
    const errorElement = document.createElement("div");
    errorElement.className = "cart-error";
    errorElement.textContent = error.error || "Cart operation failed";
    document.getElementById("cart-drawer").prepend(errorElement);
    setTimeout(() => errorElement.remove(), 3000);
  }

  // Global max quantity limit
  const GLOBAL_MAX_QUANTITY = 3;

  async function handleQuantityChange(element, change) {
    const quantityControl = element.closest(".cart-item");
    const input = quantityControl.querySelector("[data-quantity-input]");
    const itemKey = quantityControl.dataset.itemId;
    const stockMaxQuantity = parseInt(quantityControl.dataset.maxQuantity) || 9999;
    // Use the lower of stock availability and global max
    const maxQuantity = Math.min(stockMaxQuantity, GLOBAL_MAX_QUANTITY);
    let newQuantity = Number(input.value) + change;

    // Validate against max quantity (3 or stock, whichever is lower)
    if (newQuantity > maxQuantity) {
      const message = maxQuantity === GLOBAL_MAX_QUANTITY
        ? `Maximum ${GLOBAL_MAX_QUANTITY} per product`
        : `Only ${maxQuantity} available`;
      showStockError(quantityControl, message);
      input.value = maxQuantity;
      return;
    }

    if (newQuantity < 1) {
      newQuantity = 1; // Minimum quantity
    }

    input.value = newQuantity;
    quantityControl.classList.add("updating");

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: itemKey, quantity: newQuantity }),
      });

      const cartData = await response.json();

      publish(PUB_SUB_EVENTS.cartUpdate, {
        action: "update",
        itemKey: itemKey,
        quantity: newQuantity,
        cart: cartData,
      });

      await refreshCartContent(cartData);
    } catch (error) {
      publish(PUB_SUB_EVENTS.cartError, {
        error: error.message,
        context: "update-quantity",
      });

      // Reset to previous value on error
      input.value = Number(input.value) - change;
    } finally {
      quantityControl.classList.remove("updating");
    }
  }

  function openCartDrawer() {
    const cartDrawer = document.getElementById("cart-drawer");
    cartDrawer.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  function closeCartDrawer() {
    const cartDrawer = document.getElementById("cart-drawer");
    cartDrawer.classList.remove("open");
    document.body.style.overflow = "";
  }

  async function handleRemoveItem(button) {
    const itemElement = button.closest(".cart-item");
    const itemKey = itemElement.dataset.itemId;

    try {
      button.disabled = true;
      itemElement.classList.add("removing");

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id: itemKey, quantity: 0 }),
      });

      const cartData = await response.json();

      publish(PUB_SUB_EVENTS.cartUpdate, {
        action: "remove",
        itemKey: itemKey,
        cart: cartData,
      });

      await refreshCartContent(cartData);
    } catch (error) {
      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "remove-item",
        });
      }
      button.disabled = false;
      itemElement.classList.remove("removing");
    }
  }

  async function refreshCartContent(cartData) {
    try {
      const cartContent = document.querySelector(
        "#cart-drawer .cart-drawer__items"
      );
      if (!cartContent) return;

      cartContent.classList.add("loading");

      const response = await fetch("/?section_id=main-cart");
      if (!response.ok) throw new Error("Failed to fetch cart content");

      const text = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = text;

      const newCartContent = tempDiv.querySelector(
        "#cart-drawer .cart-drawer__items"
      );
      if (!newCartContent)
        throw new Error("Cart content not found in response");

      cartContent.innerHTML = newCartContent.innerHTML;

      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();

      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = cartData.item_count;
      });

      // Update shipping bar
      updateShippingBar(cartData);
    } catch (error) {
      console.error("Error refreshing cart content:", error);
    } finally {
      const cartContent = document.querySelector(
        "#cart-drawer .cart-drawer__items"
      );
      if (cartContent) cartContent.classList.remove("loading");
    }
  }

  function updateShippingBar(cartData) {
    const freeShippingEnabled =
      document.querySelector(".free-shipping-bar")?.dataset
        .freeShippingEnabled === "true";

    if (!freeShippingEnabled) return;

    const shippingBar = document.querySelector(".free-shipping-bar");

    const threshold = parseInt(shippingBar.dataset.shippingThreshold) * 100;
    const currentTotal = cartData.total_price;
    const remaining = threshold - currentTotal;
    const moneyFormat = shippingBar.dataset.moneyFormat;

    const shippingMessage = document.querySelector(".free-shipping-message");
    const progressBar = document.querySelector(".progress-bar .progress");
    const shippingCostElement = document.querySelector(".shipping-message");

    const beforeMessage = shippingBar.dataset.beforeMessage;
    const afterMessage = shippingBar.dataset.afterMessage;

    const congratulationsMessage = shippingBar.dataset.congratulationsMessage;

    if (remaining > 0) {
      // Update progress message
      if (shippingMessage) {
        shippingMessage.innerHTML = `<span>${beforeMessage}</span> <span>${Shopify.formatMoney(
          remaining,
          window.money_without_trailing_zeros_format
        )}</span> <span>${afterMessage}</span>`;
        shippingMessage.classList.remove("success");
      }

      // Update progress bar
      const progressPercent = (currentTotal / threshold) * 100;
      progressBar.style.width = `${Math.min(progressPercent, 100)}%`;

      // Hide free shipping message if visible
      if (shippingCostElement && progressPercent >= 100) {
        shippingCostElement.style.display = "none";
      }
    } else {
      // Show success message
      if (shippingMessage) {
        shippingMessage.innerHTML = congratulationsMessage;
        shippingMessage.classList.add("success");
      }

      // Set progress to 100%
      if (progressBar) {
        progressBar.style.width = "100%";
      }

      // Show free shipping cost
      if (shippingCostElement) {
        shippingCostElement.style.display = "flex";
      }
    }
  }
});
